<template>
  <VDialog
    @click:outside="close"
    persistent
    :value="value"
    :max-width="maxWidth"
  >
    <VCard>
      <VCardTitle style="word-break: break-word" class="headline">{{
        $t(title)
      }}</VCardTitle>
      <VCardText
        ><slot>{{ $t(description) }}</slot></VCardText
      >
      <VCardActions class="justify-end">
        <VBtn color="primary" small @click="cancel">{{ $t(noText) }}</VBtn>
        <VBtn color="success" small @click="apply" :loading="loading">{{
          $t(yesText)
        }}</VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  props: {
    yesText: {
      type: String,
      default: "yesDelete",
    },
    noText: {
      type: String,
      default: "no",
    },
    maxWidth: {
      type: Number,
      default: 300,
    },
    value: {
      type: Boolean,
    },
    title: {
      type: String,
      default: "warning",
    },
    description: {
      type: String,
      default: "wantDeleteHint",
    },
  },
  data() {
    return {
      loading: false,
      payload: null,
    };
  },
  watch: {
    value(val) {
      if (val) this.$emit("opened");
      else {
        this.$emit("closed");
        this.payload = null;
      }
    },
  },
  methods: {
    open(payload) {
      this.payload = payload;
      this.$emit("input", true);
    },
    close() {
      this.$emit("input", false);
    },
    apply() {
      this.$emit("apply", this.payload);
      this.close();
    },
    cancel() {
      this.$emit("cancel");
      this.close();
    },
    setLoading(val) {
      this.loading = val;
    },
  },
};
</script>
